<template>
  <div class="main">
    <mt-header
      fixed
      title="認証ファイル"
      class="dl_header_white dl_line_bottom"
    >
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="container">
      <div class="swiper" style="margin-top: 0px">
        <p class="wx_fontSize2 tip">身分証明をしてください。</p>
      </div>

      <mt-field
        label="国家"
        placeholder="現在の居住国家"
        class="dl_margin2_top dl_line"
        readonly
        v-model="country"
      ></mt-field>
      <mt-field
        label="名前"
        placeholder="実名を入力してください"
        class="dl_margin2_top dl_line"
        v-model="u_name"
      ></mt-field>
      <mt-field
        label="誕生日"
        placeholder="誕生日を選択してください"
        class="dl_margin2_top dl_line"
        v-model="birthday"
        readonly
        @click.native="$refs.picker.open()"
      ></mt-field>

      <mt-field
        label="居住地"
        placeholder="現住地"
        class="dl_margin2_top dl_line"
        v-model="address"
      ></mt-field>
      <mt-radio
        title="タイプ"
        v-model="paperType"
        :options="[
          { label: '身分証明書', value: 'idcard' },
          { label: 'パスポート', value: 'passport' },
          { label: '免許', value: 'driving_licence' },
        ]"
      >
      </mt-radio>
      <mt-field
        label="ID番号"
        placeholder="IDを入力してください"
        class="dl_margin2_top dl_line"
        v-model="photo_id"
      ></mt-field>
      <div class="label dl_margin2_top" v-show="paperType == 'idcard'">
        {{ $t("身分証明書") }}
      </div>
      <div class="label dl_margin2_top" v-show="paperType == 'passport'">
        {{ $t("パスポート") }}
      </div>
      <div class="label dl_margin2_top" v-show="paperType == 'driving_licence'">
        {{ $t("免許") }}
      </div>
      <!-- <mt-field
        label="身分証明書"
        v-show="paperType == 'idcard'"
        class="dl_margin2_top"
        readonly="true"
      ></mt-field> -->
      <!-- <mt-field
        label="パスポート"
        v-show="paperType == 'passport'"
        class="dl_margin2_top"
        readonly="true"
      ></mt-field>
      <mt-field
        label="免許"
        v-show="paperType == 'driving_licence'"
        class="dl_margin2_top"
        readonly="true"
      ></mt-field> -->
      <div class="img-container">
        <template v-if="!cardUrl">
          <img class="kycImg" src="@/assets/img/realname/card01.png" alt="" />
        </template>
        <img v-else class="sfzimg" @click="fileChoose(1)" :src="cardUrl" />
        <input
          type="file"
          @change="onFileChange($event, 1)"
          ref="inputref"
          accept="image/jpeg, image/png, image/gif"
        />
      </div>
      <div class="img-container">
        <template v-if="!cardUrl2">
          <img class="kycImg" src="@/assets/img/realname/card03.png" alt="" />
        </template>
        <img v-else class="sfzimg" @click="fileChoose(2)" :src="cardUrl2" />
        <input
          type="file"
          @change="onFileChange($event, 2)"
          ref="inputref2"
          accept="image/jpeg, image/png, image/gif"
        />
      </div>
      <!-- <div class="img-container">
        <template v-if="!cardUrl3">
          <img class="kycImg" src="@/assets/img/realname/card03.png" alt="" />
        </template>
        <img v-else class="sfzimg" @click="fileChoose(3)" :src="cardUrl3" />
        <input
          type="file"
          @change="onFileChange($event, 3)"
          ref="inputref2"
          accept="image/jpeg, image/png, image/gif"
        />
      </div> -->
      <mt-button size="large" type="primary" @click="doApply()">{{
        $t("提交")
      }}</mt-button>
    </div>
    <mt-datetime-picker
      ref="picker"
      type="date"
      :startDate="startDate"
      @confirm="onConfirm"
    ></mt-datetime-picker>
  </div>
</template>

<script>
import { httpUpload, httpAddAuth } from "@/api/userCenter";
import { Toast } from "mint-ui";
import { parseTime } from "@/utils/index";
export default {
  data() {
    return {
      country: "",
      u_name: "",
      birthday: "",
      address: "",
      photo_id: "",
      cardUrl: "",
      cardUrl2: "",
      // cardUrl3: "",
      index: 1,
      paperType: "idcard",
      startDate: new Date("1920/01/01"),
    };
  },
  mounted: function () {},
  methods: {
    onConfirm(value) {
      this.birthday = parseTime(new Date(value), "{y}-{m}-{d}");
    },
    fileChoose: function (index) {
      this.index = index;
      if (index == 1) {
        this.$refs.inputref.click();
      } else if (index == 2) {
        this.$refs.inputref2.click();
      } else {
        this.$refs.inputref3.click();
      }
    },
    onFileChange: function (e, index) {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      // formData.append("token", this.token);
      if (index == 1) {
        if (this.$refs.inputref.files.length == 0) {
          return;
        }
      } else if (index == 2) {
        if (this.$refs.inputref2.files.length == 0) {
          return;
        }
      } else if (index == 3) {
        if (this.$refs.inputref3.files.length == 0) {
          return;
        }
      }
      httpUpload(formData)
        .then((res) => {
          if (index == 1) {
            this.cardUrl = res.data.http_url;
          } else if (index == 2) {
            this.cardUrl2 = res.data.http_url;
          } else {
            this.cardUrl3 = res.data.http_url;
          }

          Toast(res.msg);
        })
        .catch(() => {});
    },
    doApply: function () {
      if (
        !this.country ||
        !this.u_name ||
        !this.birthday ||
        !this.photo_id ||
        !this.address
      ) {
        Toast("情報をきちんと記入してください");
      } else if (!this.cardUrl || !this.cardUrl2) {
        Toast("必要な画像をアップロードしてください");
      } else {
        var p = {
          country: this.country,
          u_name: this.u_name,
          birthday: this.birthday,
          photo_id: this.photo_id,
          photo_id1: this.cardUrl,
          photo_id2: this.cardUrl2,
          // photo_id3: this.cardUrl3,
          address: this.address,
          kind: this.paperType, //证件类型
        };
        httpAddAuth(p)
          .then((res) => {
            Toast(res.msg);
            // this.$router.back();
            this.$router.push("/index/mypage");
          })
          .catch(() => {});
      }
    },
  },
  computed: {},
  watch: {},
  activated: function () {
    this.country = "JP";
    this.u_name = "";
    this.birthday = "";
    this.address = "";
    this.photo_id = "";
    this.cardUrl = "";
    this.cardUrl2 = "";
    // this.cardUrl3 = "";
    this.index = 1;
    this.paperType = "idcard";
  },
};
</script>

<style scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  color: #4a4a4a;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 20px;
}
.swiper p {
  margin: 5px;
}
.sfzimg {
  margin-top: 10px;
  width: 60%;
  height: 150px;
}
.tip {
  font-weight: normal;
  color: #888;
}
.dl_line {
  border-bottom: 1px solid #f6f6f6;
}
.dl_line_top {
  border-top: 1px solid #f6f6f6;
}
.img-container {
  position: relative;
  text-align: center;
  width: 100%;
}
.img-container input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.mint-radiolist {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f6f6f6;
}
/deep/.mint-radiolist-title {
  font-size: 16px;
  padding-left: 0px;
  width: 62px;
  margin-left: 20px;
  color: #212529;
}
.kycImg {
  display: block;
  width: calc(100% - 30px);
  margin: 15px;
}
/deep/.mint-radiolist-label {
  padding: 0 0;
  width: 100px;
}
/deep/.mint-radio-core {
  width: 15px;
  height: 15px;
}
/deep/.mint-radio-core::after {
  top: 3px;
  left: 3px;
  width: 7px;
  height: 7px;
}
/deep/.mint-radio-label {
  margin-left: -3px;
  font-size: smaller;
}
.label {
  padding: 5px 20px;
}
</style>
